import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import * as React from 'react';
import { ConversationGridFiltersActions } from '../../../../../sic-lib/reducers/conversationGridFiltersReducer';
import { ClientField } from '../../../../../sic-lib/types/ClientField';
import { ConversationGridFiltersItem } from '../../../../../sic-lib/types/ConversationGridFiltersItem';
import MenuAddFilterGroupRaw from './MenuAddFilterGroupRaw/MenuAddFilterGroupRaw';

interface Props {
    fields: ClientField[];
    filters: ConversationGridFiltersItem[];
    formDispatch: React.Dispatch<ConversationGridFiltersActions>;
}

export default function MenuAddGroup({ fields, filters, formDispatch }: Props) {
    const menuId = 'menu_add_filter_group';

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Button
                aria-controls="menu_add_filter"
                aria-haspopup="true"
                startIcon={<AddIcon />}
                onClick={handleOpen}
            >
                Add Condition
            </Button>
            <MenuAddFilterGroupRaw
                anchorEl={anchorEl}
                menuId={menuId}
                fields={fields}
                filters={filters}
                formDispatch={formDispatch}
                onCloseHandler={handleClose}
            />
        </React.Fragment>
    );
}
